import React from "react";
import CommonStatCard from "../../pt/pt-flow-new/CommonStatCard";
import { convertThenFormat } from "../../common-data/Converts";

const ExpenseStats = ({ allStats, onCardClick, selectedStatus }) => {
  const EXPENSE_STATS_ORDER = [
    "approved_paid",
    "approved_notpaid",
    "approval_pending",
    "rejected",
  ];

  const getCardLabel = (key) => {
    const labels = {
      approved_paid: "Approved & Paid",
      approved_notpaid: "Approved & Not Paid",
      approval_pending: "Approval Pending",
      rejected: "Rejected",
    };
    return labels[key] || key.replace(/_/g, " ");
  };

  const getCountColor = (key) => {
    const colors = {
      approved_paid: "#10b981", // Green for completed
      approved_notpaid: "#3b82f6", // Blue for in progress
      approval_pending: "#f59e0b", // Orange for pending
      rejected: "#ef4444", // Red for rejected
    };
    return colors[key] || "#6b7280"; // Default gray
  };

  const handleCardClick = (status) => {
    console.log("status", status);
    if (onCardClick) {
      // Simple mapping: approval_pending -> pending
      const filterStatus = status === "approval_pending" ? "pending" : status;
      onCardClick(filterStatus);
    }
  };

  // Get stats data with defaults
  const getCardData = (key) => {
    const defaultData = { count: 0, total_amount: 0 };
    return allStats?.[key] || defaultData;
  };

  // Check if card is selected
  const isSelected = (cardKey) => {
    if (!selectedStatus) return false;
    const mappedStatus =
      selectedStatus === "pending" ? "approval_pending" : selectedStatus;
    return cardKey === mappedStatus;
  };

  const cardStyle = {
    position: "relative",
  };

  const overlayStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    border: "3px solid #209216",
    borderRadius: "8px",
    backgroundColor: "rgba(32, 146, 22, 0.1)",
    pointerEvents: "none",
    zIndex: 1,
  };

  const checkmarkStyle = {
    position: "absolute",
    top: "8px",
    right: "8px",
    backgroundColor: "#209216",
    color: "white",
    borderRadius: "50%",
    width: "24px",
    height: "24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "12px",
    fontWeight: "bold",
    zIndex: 2,
  };

  return (
    <div className="cards-container cards-grid-container grid-expense-stats pt-flow-new">
      {EXPENSE_STATS_ORDER.map((key) => {
        const data = getCardData(key);
        const selected = isSelected(key);

        return (
          <div key={key} style={cardStyle}>
            <CommonStatCard
              tagName={key}
              cardLabel={
                <>
                  {getCardLabel(key)} (
                  <span
                    style={{
                      color: getCountColor(key),
                      fontSize: "24px",
                      fontWeight: "700",
                      backgroundColor: `${getCountColor(key)}20`,
                      padding: "1px 4px",
                      borderRadius: "12px",
                      // border: `1px solid ${getCountColor(key)}30`,
                    }}
                  >
                    {data.count}
                  </span>
                  )
                </>
              }
              value={`₹${convertThenFormat(data.total_amount)}`}
              onClickCard={handleCardClick}
            />
            {selected && <div style={overlayStyle} />}
            {selected && <div style={checkmarkStyle}>✓</div>}
          </div>
        );
      })}
    </div>
  );
};

export default ExpenseStats;
